'use strict';

exports.__esModule = true;
exports.default = undefined;

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _redux = require('redux');

var _Grid = require('react-bootstrap/lib/Grid');

var _Grid2 = _interopRequireDefault(_Grid);

var _Col = require('react-bootstrap/lib/Col');

var _Col2 = _interopRequireDefault(_Col);

var _Row = require('react-bootstrap/lib/Row');

var _Row2 = _interopRequireDefault(_Row);

var _mozart_ui = require('@pgforsta/mozart_ui');

var _components = require('components');

var _reactAddonsCssTransitionGroup = require('react-addons-css-transition-group');

var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);

var _reactMobileDatepicker = require('react-mobile-datepicker');

var _reactMobileDatepicker2 = _interopRequireDefault(_reactMobileDatepicker);

var _momentTimezone = require('moment-timezone');

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _utilElement = require('utils/util-element');

var _survey = require('redux/modules/survey');

var _utilElement2 = require('utils/util-element.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SurveyQuestions = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    survey: state.survey.data.data,
    selectedLanguage: state.survey.selectedLanguage,
    createdAudienceInfo: state.survey.createdAudienceInfo,
    audienceInfo: state.survey.audienceInfo
  };
}, function (dispatch) {
  return (0, _redux.bindActionCreators)({ createAudience: _survey.createAudience }, dispatch);
}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(SurveyQuestions, _Component);

  function SurveyQuestions(props) {
    (0, _classCallCheck3.default)(this, SurveyQuestions);

    var _this = (0, _possibleConstructorReturn3.default)(this, _Component.call(this, props));

    _this.handleDatePickerClick = function () {
      _this.setState({ is_datepicker_open: true });
    };

    _this.handleDatePickerCancel = function () {
      _this.setState({ is_datepicker_open: false });
    };

    _this.handleDatePickerSelect = function (time) {
      _this.setState({ is_datepicker_open: false }, function () {
        _this.setData(1, (0, _momentTimezone2.default)(time).format('MM-DD-YYYY'));
        document.getElementById('date_box_mobile_' + _this.state.sequence_no).value = (0, _momentTimezone2.default)(time).format('MM-DD-YYYY');
      });
    };

    _this.styles = require('./SurveyQuestions.scss');
    _this.state = {
      current_move: 'forward',
      sequence_no: 1,
      page_no: 1,
      height: window.innerHeight || document.documentElement.clientHeight,
      width: window.innerWidth || document.documentElement.clientWidth,
      device_type: (window.innerWidth || document.documentElement.clientWidth) <= 768 ? 'mobile' : 'desktop',
      feedback_data: {},
      current_question: {},
      is_datepicker_open: false,
      disable_next: false,
      current_question_instruction: false,
      anonymous_survey: false,
      show_anonymous_dialog: false
    };
    _this.eval = eval;
    (0, _utilElement2.fireGTMEvent)(_utilElement2.EVENT_PAGE_LOAD, _utilElement2.EVENT_PAGE_LOAD, 'Loading survey questions page.');
    return _this;
  }

  SurveyQuestions.prototype.componentDidMount = function componentDidMount() {
    var clientId = this.props.params.clientId;
    var audienceCode = this.props.params.code;
    var sourceId = this.props.surveyId;
    var self = this;
    setTimeout(function clbk() {
      self.setMarginTop();
    }, 100);
    if (!this.props.createdAudienceInfo && this.props.survey.enableRedirection && audienceCode && !this.props.previewMode && !this.props.audienceInfo.data.hasSurveySubmitted) {
      this.props.createAudience(clientId, { parentCode: audienceCode, sourceId: sourceId });
    }
  };

  SurveyQuestions.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    console.log('componenent updated' + prevProps + prevState);
    //     this.setFocus();
    this.setMarginTop();
  };

  SurveyQuestions.prototype.setMarginTop = function setMarginTop() {
    var questionComponentHeight = document.getElementById('survey_questions_options_wrapper').offsetHeight;
    var screenHeight = this.state.height;
    var constantHeight = 110 + 60;
    var availableHeight = screenHeight - constantHeight;
    var fit = availableHeight - questionComponentHeight;
    if (fit < 0) {
      document.getElementById('survey_questions_options_wrapper').style.marginTop = '0px';
    } else {
      document.getElementById('survey_questions_options_wrapper').style.marginTop = Math.ceil(fit / 2) + 'px';
    }
  };

  SurveyQuestions.prototype.getActivePageNumber = function getActivePageNumber() {
    (0, _utilElement2.fireGTMEvent)(_utilElement2.EVENT_SET_DATA, _utilElement2.EVENT_SET_DATA, 'Currrent page number : ' + this.state.page_no);
    var style = { color: this.props.theme && this.props.theme.customTextColor ? this.props.theme.customTextColor : '#fff', backgroundColor: this.props.theme && this.props.theme.colorCode ? this.props.theme.colorCode : '#fff', borderColor: this.props.theme && this.props.theme.colorCode ? this.props.theme.colorCode : '#fff' };
    return _react2.default.createElement(
      'div',
      { className: this.styles.sequence_no },
      _react2.default.createElement(
        'span',
        { className: this.styles.sequence_number, style: style },
        this.state.page_no
      )
    );
  };

  SurveyQuestions.prototype.getLogicalOperator = function getLogicalOperator(operatorString) {
    var operator = false;
    switch (operatorString) {
      case 'and':
        operator = '&&';
        break;
      case 'or':
        operator = '||';
        break;
      default:
        operator = false;
        break;
    }
    return operator;
  };

  SurveyQuestions.prototype.getConstraint = function getConstraint(constraintString) {
    var operator = false;
    switch (constraintString) {
      case 'option_eq':
        operator = '===';
        break;
      case 'option_ne':
        operator = '!==';
        break;
      default:
        operator = false;
        break;
    }
    return operator;
  };

  SurveyQuestions.prototype.getInstruction = function getInstruction() {
    return _react2.default.createElement(
      'div',
      { className: this.styles.instruction_container },
      this.state.current_question_instruction && _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'span',
          null,
          this.state.current_question_instruction
        ),
        _react2.default.createElement('div', { className: this.styles.instruction_seperator })
      )
    );
  };

  SurveyQuestions.prototype.getQuestion = function getQuestion() {
    var questions = this.props.survey.questionGroups;
    var currentQuestionTitle = '';
    if (questions && questions.length > 0) {
      if (questions[this.state.sequence_no - 1] !== undefined) {
        if (questions[this.state.sequence_no - 1].type === 'Question') {
          // For single question
          var sequenceQuestion = questions[this.state.sequence_no - 1].questions[0];
          if (!sequenceQuestion.rule) {
            // If no rule is applicable, set the question
            currentQuestionTitle = (0, _utilElement.getTextForLanguage)(sequenceQuestion.title, this.props.selectedLanguage);
            this.state.current_question = sequenceQuestion;
            this.state.current_question_instruction = sequenceQuestion.instruction ? (0, _utilElement.getTextForLanguage)(sequenceQuestion.instruction, this.props.selectedLanguage) : false;
          } else {
            // If rule is applicable
            if (this.checkRule(sequenceQuestion)) {
              // if rule is passed, then set the question
              currentQuestionTitle = (0, _utilElement.getTextForLanguage)(sequenceQuestion.title, this.props.selectedLanguage);
              this.state.current_question = sequenceQuestion;
              this.state.current_question_instruction = sequenceQuestion.instruction ? (0, _utilElement.getTextForLanguage)(sequenceQuestion.instruction, this.props.selectedLanguage) : false;
            } else {
              // If rule failed, go for next question
              if (this.state.current_move === 'forward') {
                this.setNextButtonClick(false);
              } else {
                this.setBackButtonClick(false);
              }
            }
          }
          this.state.current_question.questionGroup = false;
        } else {
          // For group question
          currentQuestionTitle = (0, _utilElement.getTextForLanguage)(questions[this.state.sequence_no - 1].title, this.props.selectedLanguage);
          this.state.current_question = questions[this.state.sequence_no - 1];
          this.state.current_question.questionGroup = true;
          this.state.current_question_instruction = questions[this.state.sequence_no - 1].instruction ? (0, _utilElement.getTextForLanguage)(questions[this.state.sequence_no - 1].instruction, this.props.selectedLanguage) : false;
        }
      } else {
        console.error('Sequence no ' + this.state.sequence_no - 1 + ' is not availabale');
      }
    }
    return _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'div',
        { className: this.styles.instruction_container },
        this.state.current_question_instruction && _react2.default.createElement(
          'div',
          { 'data-qa-type': 'instructions' },
          _react2.default.createElement(
            'span',
            null,
            this.state.current_question_instruction
          ),
          _react2.default.createElement('div', { className: this.styles.instruction_seperator })
        )
      ),
      _react2.default.createElement(
        'div',
        { className: this.styles.question_container },
        _react2.default.createElement(
          'span',
          null,
          currentQuestionTitle
        )
      )
    );
  };

  SurveyQuestions.prototype.setData = function setData(optionId, optionName, questionId) {
    //     const currentQuestion = this.props.surveyprops.survey.questionGroupssequence_no - 1];
    var currentQuestionId = 0;
    if (questionId && (typeof questionId === 'undefined' ? 'undefined' : (0, _typeof3.default)(questionId)) !== 'object') {
      currentQuestionId = questionId;
      this.state.feedback_data[questionId] = { optionId: optionId, response: optionName ? optionName : '' };
    } else {
      var currentQuestion = this.state.current_question;
      currentQuestionId = currentQuestion.id;
      this.state.feedback_data[currentQuestion.id] = { optionId: optionId, response: optionName ? optionName : '' };
    }
    //     if (this.isAutoSkippableQuestion()) {
    //       this.setState({feedback_data: this.state.feedback_data}, () => {
    //         setTimeout( () => {
    //           this.setState({sequence_no: this.state.sequence_no + 1});
    //         }, 1000);
    //       });
    //     } else {
    this.setState({ feedback_data: this.state.feedback_data });
    (0, _utilElement2.fireGTMEvent)(_utilElement2.EVENT_SET_DATA, _utilElement2.EVENT_SET_DATA, 'Answering question : ' + currentQuestionId + ' option id : ' + optionId + ' option name : ' + optionName);
    //     }
  };

  SurveyQuestions.prototype.getSingleSelectRatingButtons = function getSingleSelectRatingButtons(options) {
    var _this2 = this;

    // const options = [{id: 1, score: 1, name: {en: '1'}}, {id: 2, score: 2, name: {en: '2'}}, {id: 3, score: 3, name: {en: '3'}}, {id: 4, score: 4, name: {en: '4'}}, {id: 5, score: 5, name: {en: '5'}}, {id: 6, score: 6, name: {en: '6'}}, {id: 7, score: 7, name: {en: '7'}}, {id: 8, score: 8, name: {en: '8'}}, {id: 9, score: 9, name: {en: '9'}}, {id: 10, score: 10, name: {en: '10'}}];
    var component = [];
    var leftlabel = '';
    var rightlabel = '';
    var style = {
      display: navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1 ? '-webkit-flex' : 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      '-webkitAlignTtems': 'center',
      '-webkitJustifyContent': 'center',
      color: '#4A4A4A',
      fontSize: '16px',
      border: 'none'
    };
    var selectedStyle = {
      display: navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1 ? '-webkit-flex' : 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      '-webkitAlignTtems': 'center',
      '-webkitJustifyContent': 'center',
      color: '#ffffff',
      fontSize: '16px',
      boxSizing: 'border-box',
      border: '2px solid #FFFFFF',
      background: 'linear-gradient(180deg, #FCA74F 0%, #F76E27 100%)',
      boxShadow: '0 4px 7px -5px rgba(0,0,0,0.5)'
    };
    if (options) {
      var reversedOptions = options.slice().reverse();
      reversedOptions.map(function (item, index) {
        // const optionLabel = item.name[this.props.selectedLanguage];
        component.push(_react2.default.createElement(_mozart_ui.MozartIcon, {
          height: _this2.state.device_type === 'mobile' ? '30px' : '36px',
          width: _this2.state.device_type === 'mobile' ? '30px' : '36px',
          style: _this2.state.feedback_data[_this2.state.current_question.id] && _this2.state.feedback_data[_this2.state.current_question.id].optionId === item.id ? selectedStyle : style,
          hoverColor: 'white',
          data: index + 1,
          onClick: _this2.setData.bind(_this2, item.id, (0, _utilElement.getTextForLanguage)(options.find(function (current) {
            return current.id === item.id;
          }).name, _this2.props.selectedLanguage))
        }));
      });
    }
    rightlabel = (0, _utilElement.getTextForLanguage)(options[0].name, this.props.selectedLanguage);
    leftlabel = (0, _utilElement.getTextForLanguage)(options[options.length - 1].name, this.props.selectedLanguage);
    return _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'div',
        { className: this.styles.single_select_rating_button_label },
        _react2.default.createElement(
          'div',
          null,
          leftlabel
        ),
        _react2.default.createElement(
          'div',
          null,
          rightlabel
        )
      ),
      _react2.default.createElement(
        'div',
        { className: this.styles.single_select_rating_button_container, 'data-qa-type': 'single_select_rating_container' },
        component
      )
    );
  };

  SurveyQuestions.prototype.getDatePicker = function getDatePicker() {
    var _this3 = this;

    var component = [];
    var dateVal = this.state.feedback_data[this.state.current_question.id] && this.state.feedback_data[this.state.current_question.id].response ? (0, _momentTimezone2.default)(this.state.feedback_data[this.state.current_question.id].response, 'MM-DD-YYYY').format('MM-DD-YYYY') : (0, _momentTimezone2.default)(new Date(), 'MM-DD-YYYY').format('MM-DD-YYYY');
    if (this.state.device_type === 'mobile') {
      component.push(_react2.default.createElement(
        'div',
        { className: this.styles.datepicker_container },
        _react2.default.createElement(_mozart_ui.MozartTextBox, {
          style: { border: '1px solid ' + this.props.theme.colorCode, height: '36px' },
          ref: 'date_box_mobile',
          id: 'date_box_mobile_' + this.state.sequence_no,
          className: 'comment_textarea',
          name: 'date_box_mobile_' + this.state.sequence_no,
          multiLine: false,
          key: dateVal,
          validationBool: false,
          multipleLineArea: false,
          onChange: this.dateChange.bind(this),
          onBlur: this.dateBlur.bind(this),
          hintText: 'MM-DD-YYYY',
          value: dateVal,
          icon: _react2.default.createElement('span', { className: 'icon-Calendar', onClick: function onClick() {
              _this3.handleDatePickerClick();
              if (_this3.refs['date_picker_mobile_' + _this3.state.sequence_no]) {
                _this3.refs['date_picker_mobile_' + _this3.state.sequence_no].focus();
              }
            } })
        }),
        _react2.default.createElement(_reactMobileDatepicker2.default, {
          ref: 'date_picker_mobile_' + this.state.sequence_no,
          value: new Date(dateVal.split('-').join('/'))
          // value={new Date()}
          , isOpen: this.state.is_datepicker_open,
          onSelect: this.handleDatePickerSelect,
          onCancel: this.handleDatePickerCancel,
          confirmText: 'Ok',
          cancelText: 'Cancel'
        })
      ));
    } else {
      component.push(_react2.default.createElement(
        'div',
        { className: this.styles.datepicker_container },
        _react2.default.createElement(_components.DatePickerWeb, { key: dateVal, value: dateVal, onChange: function onChange(selectedDate) {
            _this3.setData(1, selectedDate);
          } })
      ));
    }
    return _react2.default.createElement(
      'div',
      { style: { width: '100%' }, 'data-qa-type': 'datepicker_container' },
      component
    );
  };

  SurveyQuestions.prototype.getSingleSelectSlider = function getSingleSelectSlider(options) {
    var _this4 = this;

    // const options = [{id: 1, score: 1, name: {en: '1'}}, {id: 2, score: 2, name: {en: '2'}}, {id: 3, score: 3, name: {en: '3'}}, {id: 4, score: 4, name: {en: '4'}}, {id: 5, score: 5, name: {en: '5'}}, {id: 6, score: 6, name: {en: '6'}}, {id: 7, score: 7, name: {en: '7'}}, {id: 8, score: 8, name: {en: '8'}}, {id: 9, score: 9, name: {en: '9'}}, {id: 10, score: 10, name: {en: '10'}}];
    var defaultValue = null;
    defaultValue = options.filter(function (item) {
      return item.defaultOption;
    });
    if (defaultValue.length > 0 && !this.state.feedback_data[this.state.current_question.id]) {
      this.setData(defaultValue[0].id, (0, _utilElement.getTextForLanguage)(defaultValue[0].name, this.props.selectedLanguage));
    }
    var component = [];
    component.push(_react2.default.createElement(_components.MozartSlider, {
      min: options[0].id,
      max: options[options.length - 1].id,
      step: 1,
      labels: [(0, _utilElement.getTextForLanguage)(options[0].name, this.props.selectedLanguage), (0, _utilElement.getTextForLanguage)(options[options.length - 1].name, this.props.selectedLanguage)],
      value: this.state.feedback_data[this.state.current_question.id] && this.state.feedback_data[this.state.current_question.id].optionId !== undefined && this.state.feedback_data[this.state.current_question.id].optionId !== null ? this.state.feedback_data[this.state.current_question.id].optionId : options[options.length - 1].id,
      onChange: function onChange(selectedItem) {
        _this4.setData(selectedItem, (0, _utilElement.getTextForLanguage)(options.find(function (current) {
          return current.id === selectedItem;
        }).name, _this4.props.selectedLanguage));
      }
    }));
    return _react2.default.createElement(
      'div',
      { style: { width: '100%' }, 'data-qa-type': 'single_select_slider_container' },
      component
    );
  };

  SurveyQuestions.prototype.getStarRating = function getStarRating(options) {
    var _this5 = this;

    // const options = [{id: 1, score: 1, name: {en: '1'}}, {id: 2, score: 2, name: {en: '2'}}, {id: 3, score: 3, name: {en: '3'}}, {id: 4, score: 4, name: {en: '4'}}, {id: 5, score: 5, name: {en: '5'}}, {id: 6, score: 6, name: {en: '6'}}, {id: 7, score: 7, name: {en: '7'}}, {id: 8, score: 8, name: {en: '8'}}, {id: 9, score: 9, name: {en: '9'}}, {id: 10, score: 10, name: {en: '10'}}];
    var component = [];
    component.push(_react2.default.createElement(_mozart_ui.MozartStarRating, {
      interactive: true,
      stars: this.state.feedback_data[this.state.current_question.id] && this.state.feedback_data[this.state.current_question.id].optionId ? this.state.feedback_data[this.state.current_question.id].optionId : 0,
      leftLabel: (0, _utilElement.getTextForLanguage)(options[0].name, this.props.selectedLanguage),
      rightLabel: (0, _utilElement.getTextForLanguage)(options[options.length - 1].name, this.props.selectedLanguage),
      onChange: function onChange(selectedItem) {
        _this5.setData(selectedItem, (0, _utilElement.getTextForLanguage)(options.find(function (current) {
          return current.id === selectedItem;
        }).name, _this5.props.selectedLanguage));
      }
    }));
    return _react2.default.createElement(
      'div',
      { 'data-qa-type': 'star_rating_container', className: this.styles.star_rating_container },
      component
    );
  };

  SurveyQuestions.prototype.getRadioButtons = function getRadioButtons(options) {
    var _this6 = this;

    var component = [];
    if (options) {
      options.map(function (item, index) {
        var optionLabel = (0, _utilElement.getTextForLanguage)(item.name, _this6.props.selectedLanguage);
        component.push(_react2.default.createElement(
          'div',
          { 'data-qa-type': 'radiobutton_item' },
          _react2.default.createElement(
            _mozart_ui.MozartRadio,
            null,
            _react2.default.createElement('input', {
              ref: 'radio_' + _this6.state.sequence_no + '_' + index,
              type: 'radio',
              id: 'radio_' + _this6.state.sequence_no + '_' + index,
              key: Math.random(),
              name: 'radio_' + _this6.state.sequence_no,
              onChange: _this6.setData.bind(_this6, item.id, optionLabel),
              defaultValue: item.id,
              checked: _this6.state.feedback_data[_this6.state.current_question.id] && _this6.state.feedback_data[_this6.state.current_question.id].optionId === item.id ? true : false
            }),
            _react2.default.createElement(
              'label',
              { style: { marginRight: '10px' }, htmlFor: 'radio_' + _this6.state.sequence_no + '_' + index, title: optionLabel },
              optionLabel
            )
          )
        ));
      });
    }
    return _react2.default.createElement(
      'div',
      { 'data-qa-type': 'radiobutton_container' },
      component
    );
  };

  SurveyQuestions.prototype.getGroupQuestionOptions = function getGroupQuestionOptions(question, options) {
    var _this7 = this;

    var optionComponent = [];
    options.map(function (item) {
      if (_this7.state.current_question.renderType === 'Single Select') {
        optionComponent.push(_react2.default.createElement(
          'div',
          { className: _this7.styles.group_question_item_option, onClick: _this7.setData.bind(_this7, item.id, (0, _utilElement.getTextForLanguage)(item.name, _this7.props.selectedLanguage), question) },
          _react2.default.createElement(
            'div',
            { className: _this7.styles.group_question_item_option_text },
            (0, _utilElement.getTextForLanguage)(item.name, _this7.props.selectedLanguage)
          ),
          _react2.default.createElement(
            'div',
            { className: _this7.styles.group_question_item_option_radio },
            _react2.default.createElement(
              'div',
              { 'data-qa-type': 'radiobutton_item', style: { float: 'right', width: '100%' } },
              _react2.default.createElement(
                _mozart_ui.MozartRadio,
                { style: { textAlign: 'right' } },
                _react2.default.createElement('input', {
                  ref: 'radio_' + _this7.state.sequence_no + '_' + question + '_' + item.id,
                  type: 'radio',
                  id: 'radio_' + _this7.state.sequence_no + '_' + question + '_' + item.id,
                  key: Math.random(),
                  name: 'radio_' + _this7.state.sequence_no + '_' + question,
                  onChange: _this7.setData.bind(_this7, item.id, (0, _utilElement.getTextForLanguage)(item.name, _this7.props.selectedLanguage), question),
                  defaultValue: item.id,
                  checked: _this7.state.feedback_data[question] && _this7.state.feedback_data[question].optionId === item.id ? true : false
                }),
                _react2.default.createElement('label', { style: { marginRight: '10px' }, htmlFor: 'radio_' + _this7.state.sequence_no + '_' + question + '_' + item.id, title: 'radio' })
              )
            )
          )
        ));
      } else {
        optionComponent.push(_react2.default.createElement(
          'div',
          { className: _this7.styles.group_question_item_option },
          _react2.default.createElement(
            'div',
            { className: _this7.styles.group_question_item_option_textbox },
            _react2.default.createElement(
              'div',
              { 'data-qa-type': 'radiobutton_item', style: { float: 'right', width: '100%' } },
              _react2.default.createElement(_mozart_ui.MozartTextBox, {
                ref: 'textbox_' + _this7.state.sequence_no + '_' + question + '_' + item.id,
                id: 'textbox_' + _this7.state.sequence_no + '_' + question + '_' + item.id,
                multiLine: false,
                validationBool: false,
                key: 'textbox_' + _this7.state.sequence_no,
                value: _this7.state.feedback_data[question] && _this7.state.feedback_data[question].response,
                onChange: function onChange(value) {
                  _this7.setData(1, value, question);
                },
                name: 'textbox_' + _this7.state.sequence_no + '_' + question + '_' + item.id,
                limit: 500
              })
            )
          )
        ));
      }
    });
    return _react2.default.createElement(
      'div',
      { 'data-qa-type': 'options_container' },
      optionComponent
    );
  };

  SurveyQuestions.prototype.getGroupQuestionColumnComponents = function getGroupQuestionColumnComponents(question, options) {
    var _this8 = this;

    var optionComponent = [];
    options.map(function (item) {
      if (_this8.state.current_question.renderType === 'Single Select') {
        optionComponent.push(_react2.default.createElement(
          _Col2.default,
          { md: 2, lg: 2, style: { width: 75 / options.length + '%' }, className: _this8.styles.group_question_item_option_radio },
          _react2.default.createElement(
            'div',
            { 'data-qa-type': 'radiobutton_item' },
            _react2.default.createElement(
              _mozart_ui.MozartRadio,
              { style: { textAlign: 'center' } },
              _react2.default.createElement('input', {
                ref: 'radio_' + _this8.state.sequence_no + '_' + question + '_' + item.id,
                type: 'radio',
                id: 'radio_' + _this8.state.sequence_no + '_' + question + '_' + item.id,
                key: Math.random(),
                name: 'radio_' + _this8.state.sequence_no + '_' + question,
                onChange: _this8.setData.bind(_this8, item.id, (0, _utilElement.getTextForLanguage)(item.name, _this8.props.selectedLanguage), question),
                defaultValue: item.id,
                checked: _this8.state.feedback_data[question] && _this8.state.feedback_data[question].optionId === item.id ? true : false
              }),
              _react2.default.createElement('label', { style: { marginRight: '10px' }, htmlFor: 'radio_' + _this8.state.sequence_no + '_' + question + '_' + item.id, title: (0, _utilElement.getTextForLanguage)(item.name, _this8.props.selectedLanguage) })
            )
          )
        ));
      } else {
        optionComponent.push(_react2.default.createElement(
          _Col2.default,
          { md: 2, lg: 2, className: _this8.styles.group_question_item_option_textbox },
          _react2.default.createElement(
            'div',
            { 'data-qa-type': 'radiobutton_item' },
            _react2.default.createElement(_mozart_ui.MozartTextBox, {
              ref: 'textbox_' + _this8.state.sequence_no + '_' + question + '_' + item.id,
              id: 'textbox_' + _this8.state.sequence_no + '_' + question + '_' + item.id,
              multiLine: false,
              validationBool: false,
              key: 'textbox_' + _this8.state.sequence_no,
              value: _this8.state.feedback_data[question] && _this8.state.feedback_data[question].response,
              onChange: function onChange(value) {
                _this8.setData(1, value, question);
              },
              name: 'textbox_' + _this8.state.sequence_no + '_' + question + '_' + item.id,
              limit: 500
            })
          )
        ));
      }
    });
    return optionComponent;
  };

  SurveyQuestions.prototype.getGroupQuestion = function getGroupQuestion() {
    var _this9 = this;

    var component = [];
    var questionComponent = [];
    var currentQuestion = this.state.current_question;
    var groupQuestions = currentQuestion.questions;
    var options = currentQuestion.options;
    //     const groupQuestions = [{'id': 1000006601, 'sequenceNo': 1, 'title': {'en': 'You Consulted: '}, 'type': 'Single Choice (Radio)', 'renderType': 'Single Select', 'description': {'en': ''}, 'groupTitle': {'en': ''}, 'required': false, 'rule': null, 'options': [{'id': 1, 'type': null, 'name': {'en': 'Provider'}, 'categoryId': 0}, {'id': 2, 'type': null, 'name': {'en': 'Nurse Only'}, 'categoryId': 0}, {'id': 3, 'type': null, 'name': {'en': 'Lab Only'}, 'categoryId': 0}, {'id': 4, 'type': null, 'name': {'en': 'EMG Only'}, 'categoryId': 0}, {'id': 5, 'type': null, 'name': {'en': 'Dressing Change Only'}, 'categoryId': 0}], 'isPhi': false, 'category': null}, {'id': 1000006602, 'sequenceNo': 1, 'title': {'en': 'You Consulted: '}, 'type': 'Single Choice (Radio)', 'renderType': 'Single Select', 'description': {'en': ''}, 'groupTitle': {'en': ''}, 'required': false, 'rule': null, 'options': [{'id': 1, 'type': null, 'name': {'en': 'Provider'}, 'categoryId': 0}, {'id': 2, 'type': null, 'name': {'en': 'Nurse Only'}, 'categoryId': 0}, {'id': 3, 'type': null, 'name': {'en': 'Lab Only'}, 'categoryId': 0}, {'id': 4, 'type': null, 'name': {'en': 'EMG Only'}, 'categoryId': 0}, {'id': 5, 'type': null, 'name': {'en': 'Dressing Change Only'}, 'categoryId': 0}], 'isPhi': false, 'category': null}, {'id': 1000006603, 'sequenceNo': 1, 'title': {'en': 'You Consulted: '}, 'type': 'Single Choice (Radio)', 'renderType': 'Single Select', 'description': {'en': ''}, 'groupTitle': {'en': ''}, 'required': false, 'rule': null, 'options': [{'id': 1, 'type': null, 'name': {'en': 'Provider'}, 'categoryId': 0}, {'id': 2, 'type': null, 'name': {'en': 'Nurse Only'}, 'categoryId': 0}, {'id': 3, 'type': null, 'name': {'en': 'Lab Only'}, 'categoryId': 0}, {'id': 4, 'type': null, 'name': {'en': 'EMG Only'}, 'categoryId': 0}, {'id': 5, 'type': null, 'name': {'en': 'Dressing Change Only'}, 'categoryId': 0}], 'isPhi': false, 'category': null}, {'id': 1000006604, 'sequenceNo': 1, 'title': {'en': 'You Consulted: '}, 'type': 'Single Choice (Radio)', 'renderType': 'Single Select', 'description': {'en': ''}, 'groupTitle': {'en': ''}, 'required': false, 'rule': null, 'options': [{'id': 1, 'type': null, 'name': {'en': 'Provider'}, 'categoryId': 0}, {'id': 2, 'type': null, 'name': {'en': 'Nurse Only'}, 'categoryId': 0}, {'id': 3, 'type': null, 'name': {'en': 'Lab Only'}, 'categoryId': 0}, {'id': 4, 'type': null, 'name': {'en': 'EMG Only'}, 'categoryId': 0}, {'id': 5, 'type': null, 'name': {'en': 'Dressing Change Only'}, 'categoryId': 0}], 'isPhi': false, 'category': null}];
    //     const options = [{'id': 1, 'type': null, 'name': {'en': 'Provider'}, 'categoryId': 0}, {'id': 2, 'type': null, 'name': {'en': 'Nurse Only'}, 'categoryId': 0}, {'id': 3, 'type': null, 'name': {'en': 'Lab Only'}, 'categoryId': 0}, {'id': 4, 'type': null, 'name': {'en': 'EMG Only'}, 'categoryId': 0}, {'id': 5, 'type': null, 'name': {'en': 'Dressing Change Only'}, 'categoryId': 0}];
    if (this.state.device_type === 'mobile') {
      groupQuestions.map(function (item) {
        if (!item.rule) {
          questionComponent.push(_react2.default.createElement(
            'div',
            { className: _this9.styles.group_question_item },
            _react2.default.createElement(
              'div',
              { className: _this9.styles.group_question_item_question },
              (0, _utilElement.getTextForLanguage)(item.title, _this9.props.selectedLanguage)
            ),
            _react2.default.createElement(
              'div',
              { className: _this9.styles.group_question_item_option_container },
              _this9.getGroupQuestionOptions(item.id, item.options)
            )
          ));
        } else {
          if (_this9.checkRule(item)) {
            // if rule is passed, then set the question
            questionComponent.push(_react2.default.createElement(
              'div',
              { className: _this9.styles.group_question_item },
              _react2.default.createElement(
                'div',
                { className: _this9.styles.group_question_item_question },
                (0, _utilElement.getTextForLanguage)(item.title, _this9.props.selectedLanguage)
              ),
              _react2.default.createElement(
                'div',
                { className: _this9.styles.group_question_item_option_container },
                _this9.getGroupQuestionOptions(item.id, item.options)
              )
            ));
          }
        }
      });
      if (!questionComponent.length) {
        if (this.state.current_move === 'forward') {
          this.setNextButtonClick(false);
        } else {
          this.setBackButtonClick(false);
        }
      } else {
        component.push(_react2.default.createElement(
          'div',
          { className: this.styles.group_question_container },
          questionComponent
        ));
      }
    } else {
      var optionsColumns = [];
      options.map(function (item) {
        optionsColumns.push(_react2.default.createElement(
          _Col2.default,
          { sm: 2, md: 2, lg: 2, style: { width: 75 / options.length + '%' } },
          (0, _utilElement.getTextForLanguage)(item.name, _this9.props.selectedLanguage)
        ));
      });
      var optionsRow = _react2.default.createElement(
        _Row2.default,
        { className: this.styles.group_question_item_option_container },
        _react2.default.createElement(_Col2.default, { sm: 2, md: 2, lg: 2, style: { width: '25%' } }),
        optionsColumns
      );
      var questionRows = [];
      groupQuestions.map(function (item) {
        if (!item.rule) {
          questionRows.push(_react2.default.createElement(
            _Row2.default,
            { className: _this9.styles.group_question_item },
            _react2.default.createElement(
              _Col2.default,
              { sm: 2, md: 2, lg: 2, style: { width: '25%' }, className: _this9.state.current_question.renderType === 'Single Select' ? _this9.styles.group_question_item_question : _this9.styles.group_question_item_question_large },
              (0, _utilElement.getTextForLanguage)(item.title, _this9.props.selectedLanguage)
            ),
            _this9.getGroupQuestionColumnComponents(item.id, item.options)
          ));
        } else {
          if (_this9.checkRule(item)) {
            // if rule is passed, then set the question
            questionRows.push(_react2.default.createElement(
              _Row2.default,
              { className: _this9.styles.group_question_item },
              _react2.default.createElement(
                _Col2.default,
                { sm: 2, md: 2, lg: 2, style: { width: '25%' }, className: _this9.state.current_question.renderType === 'Single Select' ? _this9.styles.group_question_item_question : _this9.styles.group_question_item_question_large },
                (0, _utilElement.getTextForLanguage)(item.title, _this9.props.selectedLanguage)
              ),
              _this9.getGroupQuestionColumnComponents(item.id, item.options)
            ));
          }
        }
      });
      //       component.push({optionsRow});
      //       component.push({questionRows});
      if (!questionRows.length) {
        if (this.state.current_move === 'forward') {
          this.setNextButtonClick(false);
        } else {
          this.setBackButtonClick(false);
        }
      } else {
        component.push(_react2.default.createElement(
          'div',
          { className: this.styles.group_question_container },
          this.state.current_question.renderType === 'Single Select' && optionsRow,
          questionRows
        ));
      }
    }
    return _react2.default.createElement(
      'div',
      { 'data-qa-type': 'groupquestion_container', style: { width: '100%' } },
      component
    );
  };

  SurveyQuestions.prototype.setMultipleChoiceData = function setMultipleChoiceData(elem) {
    var selectedItem = elem.id;
    var currentDataOptions = this.state.feedback_data[this.state.current_question.id] && this.state.feedback_data[this.state.current_question.id].optionId;
    var currentDataResponses = this.state.feedback_data[this.state.current_question.id] && this.state.feedback_data[this.state.current_question.id].response;
    if (currentDataOptions && currentDataOptions.indexOf(selectedItem) !== -1) {
      var index = currentDataOptions.indexOf(selectedItem);
      currentDataOptions.splice(index, 1);
      currentDataResponses.splice(index, 1);
      if (currentDataOptions.length === 0) {
        currentDataOptions = undefined;
        currentDataResponses = undefined;
      }
    } else {
      if (!currentDataOptions) {
        currentDataOptions = [];
        currentDataResponses = [];
      }
      currentDataOptions.push(selectedItem);
      currentDataResponses.push((0, _utilElement.getTextForLanguage)(elem.name, this.props.selectedLanguage));
    }
    this.setData(currentDataOptions, currentDataResponses);
  };

  SurveyQuestions.prototype.getCheckBox = function getCheckBox(options) {
    var _this10 = this;

    var component = [];
    if (options) {
      options.map(function (item, index) {
        var optionLabel = (0, _utilElement.getTextForLanguage)(item.name, _this10.props.selectedLanguage);
        component.push(_react2.default.createElement(
          _Col2.default,
          { xs: 12, sm: 12, md: 6, lg: 6, 'data-qa-type': 'checkbox_item', onClick: _this10.setMultipleChoiceData.bind(_this10, item) },
          _react2.default.createElement(
            _mozart_ui.MozartCheckBox,
            { border: _this10.state.device_type === 'mobile' },
            _react2.default.createElement('input', {
              ref: 'checkbox_' + _this10.state.sequence_no + '_' + index,
              type: 'checkbox',
              id: 'checkbox_' + _this10.state.sequence_no + '_' + index,
              name: 'checkbox_' + _this10.state.sequence_no,
              onChange: _this10.setMultipleChoiceData.bind(_this10, item),
              checked: _this10.state.feedback_data[_this10.state.current_question.id] && _this10.state.feedback_data[_this10.state.current_question.id].optionId && _this10.state.feedback_data[_this10.state.current_question.id].optionId.indexOf(item.id) !== -1 ? true : false
            }),
            _react2.default.createElement(
              'label',
              { style: { marginRight: '10px' }, htmlFor: 'checkbox_' + _this10.state.sequence_no + '_' + index, title: 'checkbox' },
              optionLabel
            )
          )
        ));
      });
    }
    return _react2.default.createElement(
      'div',
      { 'data-qa-type': 'checkbox_container' },
      component
    );
  };

  SurveyQuestions.prototype.getTextArea = function getTextArea() {
    var _this11 = this;

    var component = [];
    component.push(_react2.default.createElement(_mozart_ui.MozartTextBox, {
      style: { border: '1px solid ' + this.props.theme.colorCode },
      ref: 'textarea_' + this.state.sequence_no,
      id: 'textarea_' + this.state.sequence_no,
      className: 'comment_textarea',
      name: 'textarea_' + this.state.sequence_no,
      key: 'textarea_' + this.state.sequence_no,
      multiLine: true,
      validationBool: false,
      value: this.state.feedback_data[this.state.current_question.id] && this.state.feedback_data[this.state.current_question.id].response,
      onChange: function onChange(value) {
        _this11.setData(1, value);
      }
    }));
    return _react2.default.createElement(
      'div',
      { 'data-qa-type': 'textarea_container', className: this.styles.textarea_container },
      component
    );
  };

  SurveyQuestions.prototype.getErrorText = function getErrorText(value, validation) {
    var errorText = '';
    var currentQuestion = this.state.current_question;
    var isRequired = !currentQuestion.questionGroup ? currentQuestion.required : false;

    if (validation === 'email' && value && !this.validateEmail(value)) {
      errorText = 'Invalid email address';
    }
    if (validation === 'phone' && value && !this.validatePhone(value)) {
      errorText = 'Invalid phone number';
    }
    if (errorText !== '' && isRequired) {
      this.state.disable_next = true;
    } else if (errorText === '') {
      this.state.disable_next = false;
    }
    return errorText;
  };

  SurveyQuestions.prototype.getTextField = function getTextField(validation) {
    var _this12 = this;

    var component = [];
    var currentValue = this.state.feedback_data[this.state.current_question.id] && this.state.feedback_data[this.state.current_question.id].response;

    component.push(_react2.default.createElement(
      'div',
      { className: this.styles.textfield_container },
      _react2.default.createElement(_mozart_ui.MozartTextBox, {
        style: { border: '1px solid ' + this.props.theme.colorCode },
        ref: 'textbox_' + this.state.sequence_no,
        id: 'textbox_' + this.state.sequence_no,
        multiLine: false,
        validationBool: false,
        validateEmail: validation === 'email' ? true : false,
        validatePhone: validation === 'phone' ? true : false,
        validateNumeric: validation === 'number' ? true : false,
        key: 'textbox_' + this.state.sequence_no,
        value: currentValue,
        onChange: function onChange(value) {
          _this12.setData(1, value);
        },
        name: !validation ? 'textbox_' + this.state.sequence_no : validation,
        limit: 100
      }),
      validation && _react2.default.createElement(
        'span',
        { className: this.styles.errorText },
        this.getErrorText(currentValue, validation)
      )
    ));
    return _react2.default.createElement(
      'div',
      { 'data-qa-type': 'textfield_container' },
      component
    );
  };

  SurveyQuestions.prototype.getDropDown = function getDropDown(options) {
    var _this13 = this;

    var component = [];
    var selectOptions = [];
    var defaultValue = this.state.feedback_data[this.state.current_question.id] && this.state.feedback_data[this.state.current_question.id].optionId;

    if (options) {
      options.map(function (item) {
        var optionLabel = (0, _utilElement.getTextForLanguage)(item.name, _this13.props.selectedLanguage);
        var optionValue = item.id;
        selectOptions.push({ id: optionValue, value: optionValue, text: optionLabel });
      });
      if (this.props.providerId && !defaultValue && this.state.current_question.type === 'Physician (Radio)') {
        var tempSelected = selectOptions.find(function (current) {
          return current.id === parseInt(_this13.props.providerId, 10);
        });
        if (tempSelected) {
          this.state.feedback_data[this.state.current_question.id] = { optionId: parseInt(this.props.providerId, 10), response: tempSelected.text };
          this.setData(parseInt(this.props.providerId, 10), tempSelected.text);
          defaultValue = this.state.feedback_data[this.state.current_question.id] && this.state.feedback_data[this.state.current_question.id].optionId;
        }
      }
      component.push(_react2.default.createElement(_mozart_ui.MozartSelectField, {
        onChange: function onChange(selectedItem) {
          _this13.setData(selectedItem, selectOptions.find(function (current) {
            return current.id === selectedItem;
          }).text);
        },
        data: selectOptions,
        dropdown: 'dropdownClass',
        defaultValue: defaultValue,
        key: this.state.feedback_data[this.state.current_question.id] && this.state.feedback_data[this.state.current_question.id].optionId
      }));
    }
    return _react2.default.createElement(
      'div',
      { 'data-qa-type': 'dropdown_container', className: this.styles.dropdown_container },
      component
    );
  };

  SurveyQuestions.prototype.getComponent = function getComponent(type, options) {
    var component = [];
    switch (type) {
      case 'NPS':
        component.push(this.getSingleSelectRatingButtons(options));
        break;
      case 'Single Select':
        component.push(this.getRadioButtons(options));
        break;
      case 'Checkbox':
        component.push(this.getCheckBox(options));
        break;
      case 'Text Area':
        component.push(this.getTextArea(options));
        break;
      case 'Text Box':
        component.push(this.getTextField(false));
        break;
      case 'Slider':
      case 'Number Slider':
        component.push(this.getSingleSelectSlider(options));
        break;
      case 'Email':
        component.push(this.getTextField('email'));
        break;
      case 'Phone':
        component.push(this.getTextField('phone'));
        break;
      case 'Number':
        component.push(this.getTextField('number'));
        break;
      case 'Dropdown':
        component.push(this.getDropDown(options));
        break;
      case 'Date':
        component.push(this.getDatePicker(options));
        break;
      case 'Group Question':
        component.push(this.getGroupQuestion(options));
        break;
      case 'Star Rating':
        component.push(this.getStarRating(options));
        break;
      default:
        component.push([]);
        break;
    }
    return component;
  };

  SurveyQuestions.prototype.getOptions = function getOptions() {
    //     const currentQuestion = this.props.survey.questions[this.state.sequence_no - 1];
    var currentQuestion = this.state.current_question;
    var options = !currentQuestion.questionGroup ? currentQuestion.options : currentQuestion.options;
    var optionType = !currentQuestion.questionGroup ? currentQuestion.renderType : 'Group Question';
    var optionComponent = '';
    if (options) {
      optionComponent = this.getComponent(optionType, options);
    }
    return _react2.default.createElement(
      'div',
      { className: this.styles.option_container, scrollTop: 0, key: 'sdfsds' },
      optionComponent
    );
  };

  SurveyQuestions.prototype.setBackButtonClick = function setBackButtonClick() {
    var changePageNo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

    (0, _utilElement2.fireGTMEvent)(_utilElement2.EVENT_BTN_CLICK, _utilElement2.EVENT_BTN_CLICK, 'Back button clicked.');
    window.scrollTo(0, 0);
    this.setState({ sequence_no: this.state.sequence_no - 1, current_move: 'backward', page_no: changePageNo !== false ? this.state.page_no - 1 : this.state.page_no });
  };

  SurveyQuestions.prototype.getBackButton = function getBackButton() {
    // logic for back button
    var backButtonValue = this.props.selectedLanguage ? (0, _utilElement.getBackButtonText)()[this.props.selectedLanguage] : 'en';
    return _react2.default.createElement(_mozart_ui.MozartButton, {
      style: { border: '1px solid ' + this.props.theme.colorCode },
      data: backButtonValue,
      key: this.state.sequence_no,
      disabled: this.state.disable_next,
      onClick: this.setBackButtonClick.bind(this)
    });
  };

  SurveyQuestions.prototype.getTotalPageCount = function getTotalPageCount() {
    var _this14 = this;

    var pageCount = 0;
    if (this.props.survey && this.props.survey.questionGroups) {
      this.props.survey.questionGroups.map(function (question) {
        if (question.type === 'Question') {
          if (question.questions[0].rule) {
            if (_this14.checkRule(question.questions[0])) {
              pageCount = pageCount + 1;
            }
          } else {
            pageCount = pageCount + 1;
          }
        } else {
          var groupQuestions = question.questions;
          var failedCount = 0;
          if (groupQuestions) {
            groupQuestions.map(function (groupQuestionEach) {
              if (groupQuestionEach.rule) {
                if (!_this14.checkRule(groupQuestionEach)) {
                  failedCount = failedCount + 1;
                }
              }
            });
            if (failedCount !== groupQuestions.length) {
              pageCount = pageCount + 1;
            }
          }
        }
      });
    }
    return pageCount;
  };

  SurveyQuestions.prototype.getPageNumber = function getPageNumber() {
    return _react2.default.createElement(
      'div',
      { className: this.styles.page_number },
      _react2.default.createElement(
        'span',
        null,
        this.state.page_no + ' of ' + this.getTotalPageCount()
      )
    );
  };

  SurveyQuestions.prototype.setNextButtonClick = function setNextButtonClick(changePageNo) {
    (0, _utilElement2.fireGTMEvent)(_utilElement2.EVENT_BTN_CLICK, _utilElement2.EVENT_BTN_CLICK, 'Next button clicked.');
    window.scrollTo(0, 0);
    this.setState({ sequence_no: this.state.sequence_no + 1, current_move: 'forward', page_no: changePageNo !== false ? this.state.page_no + 1 : this.state.page_no });
  };

  SurveyQuestions.prototype.setAnonymousSurvey = function setAnonymousSurvey() {
    this.setState({
      anonymous_survey: !this.state.anonymous_survey
    });
  };

  SurveyQuestions.prototype.getNextButton = function getNextButton() {
    var currentQuestion = this.state.current_question;
    var nextButton = '';
    if (this.checkRequired()) {
      nextButton = _react2.default.createElement(
        'span',
        { className: this.styles.required_question_label },
        'This is a required question'
      );
    } else if (this.state.page_no === this.getTotalPageCount()) {
      // logic for submit button
      var submitButtonValue = this.props.selectedLanguage ? (0, _utilElement.getSubmitButtonText)()[this.props.selectedLanguage] : 'en';
      nextButton = _react2.default.createElement(_mozart_ui.MozartButton, {
        background: this.props.theme && this.props.theme.colorCode ? this.props.theme.colorCode : true,
        color: this.props.theme && this.props.theme.customTextColor ? this.props.theme.customTextColor : '#fff',
        data: submitButtonValue,
        style: { border: '1px solid ' + this.props.theme.colorCode },
        disabled: this.state.disable_next,
        onClick: this.props.survey.showAnonymous ? this.toggleAnonymousModal.bind(this) : this.submitSurvey.bind(this)
      });
    } else {
      if (this.isAutoSkippableQuestion() && !(this.state.feedback_data[currentQuestion.id] && this.state.feedback_data[currentQuestion.id].optionId !== undefined && this.state.feedback_data[currentQuestion.id].optionId !== null)) {
        // logic for skip button
        var skipButtonValue = this.props.selectedLanguage ? (0, _utilElement.getSkipButtonText)()[this.props.selectedLanguage] : 'en';
        nextButton = _react2.default.createElement(_mozart_ui.MozartButton, {
          data: skipButtonValue,
          key: this.state.sequence_no,
          style: { border: '1px solid ' + this.props.theme.colorCode },
          disabled: this.state.disable_next,
          onClick: this.setNextButtonClick.bind(this)
        });
      } else {
        // logic for Next button
        var nextButtonValue = this.props.selectedLanguage ? (0, _utilElement.getNextButtonText)()[this.props.selectedLanguage] : 'en';
        nextButton = _react2.default.createElement(_mozart_ui.MozartButton, {
          background: this.props.theme && this.props.theme.colorCode ? this.props.theme.colorCode : true,
          color: this.props.theme && this.props.theme.customTextColor ? this.props.theme.customTextColor : '#fff',
          data: nextButtonValue,
          key: this.state.sequence_no,
          style: { border: '1px solid ' + this.props.theme.colorCode },
          disabled: this.state.disable_next,
          onClick: this.setNextButtonClick.bind(this)
        });
      }
    }
    return nextButton;
  };

  SurveyQuestions.prototype.setFocus = function setFocus() {
    if (!(0, _utilElement.checkDevice)()) {
      var currentQuestion = this.state.current_question;
      var optionType = !currentQuestion.questionGroup ? currentQuestion.renderType : 'Group Question';
      switch (optionType) {
        case 'Date':
        case 'Text Area':
          if (document.getElementById('textarea_' + this.state.sequence_no)) {
            document.getElementById('textarea_' + this.state.sequence_no).focus();
          }
          break;
        case 'Email':
        case 'Phone':
        case 'Number':
        case 'Text Box':
          if (document.getElementById('textbox_' + this.state.sequence_no)) {
            document.getElementById('textbox_' + this.state.sequence_no).focus();
          }
          break;
        case 'Slider':
        case 'Number Slider':
          break;
        case 'Dropdown':
          break;
        default:
          break;
      }
    }
  };

  SurveyQuestions.prototype.getPageContent = function getPageContent() {
    return _react2.default.createElement(
      'div',
      { key: this.state.sequence_no, style: { height: '100%' } },
      _react2.default.createElement(
        'div',
        { style: { zIndex: '-1', height: '100%' } },
        _react2.default.createElement(
          _Row2.default,
          { className: this.styles.survey_questions_options_wrapper, id: 'survey_questions_options_wrapper',
            style: { borderColor: this.props.theme && this.props.theme.colorCode ? this.props.theme.colorCode : '#00253B' } },
          _react2.default.createElement(
            _Col2.default,
            { xs: 12, sm: 12, md: 12, 'data-qa-type': 'page-number', id: 'survey_pagenumber_wrapper' },
            this.getActivePageNumber()
          ),
          _react2.default.createElement(
            _Col2.default,
            { xs: 12, sm: 12, md: 12, 'data-qa-type': 'title', style: { minHeight: '10%' }, id: 'survey_questions_wrapper' },
            this.getQuestion()
          ),
          _react2.default.createElement(
            _Col2.default,
            { xs: 12, sm: 12, md: 12, 'data-qa-type': 'options', style: { height: '90%' }, id: 'survey_options_wrapper' },
            this.getOptions()
          )
        )
      )
    );
  };

  SurveyQuestions.prototype.toggleAnonymousModal = function toggleAnonymousModal() {
    this.setState({
      show_anonymous_dialog: !this.state.show_anonymous_dialog
    });
  };

  SurveyQuestions.prototype.currentDataRequired = function currentDataRequired(currentData) {
    var required = false;
    if (currentData && currentData.optionId && currentData.response) {
      if (Array.isArray(currentData.response)) {
        required = currentData.response.length > 0;
      } else if (typeof currentData.response === 'string') {
        required = currentData.response.trim() !== '';
      }
    }
    return required;
  };

  SurveyQuestions.prototype.checkRequired = function checkRequired() {
    var _this15 = this;

    var required = false;
    var currentQuestion = this.state.current_question;
    if (currentQuestion.questionGroup) {
      var groupQuestions = currentQuestion.questions;
      groupQuestions.map(function (item) {
        var currentData = _this15.state.feedback_data[item.id] ? _this15.state.feedback_data[item.id] : '';
        if (item.required && !_this15.currentDataRequired(currentData)) {
          required = true;
        }
      });
    } else {
      if (currentQuestion.renderType === 'Number Slider') {
        required = currentQuestion.required && !(this.state.feedback_data[currentQuestion.id] && this.state.feedback_data[currentQuestion.id].optionId !== undefined && this.state.feedback_data[currentQuestion.id].optionId !== null && this.state.feedback_data[currentQuestion.id].response.trim() !== '');
      } else {
        var currentData = this.state.feedback_data[currentQuestion.id] ? this.state.feedback_data[currentQuestion.id] : '';
        required = currentQuestion.required && !this.currentDataRequired(currentData);
      }
    }
    return required;
  };

  SurveyQuestions.prototype.validateEmail = function validateEmail(value) {
    var regex = /^(([^<>()\[\]\\,;:\s@"]+(\.[^<>()\[\]\\,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z0-9.-]+\.)+[a-zA-Z]{2,20}))$/;
    return regex.test(value);
  };

  SurveyQuestions.prototype.validatePhone = function validatePhone(value) {
    var regex = /^\d{10}$/;
    return regex.test(value);
  };

  SurveyQuestions.prototype.checkRule = function checkRule(question) {
    var _this16 = this;

    var rule = question.rule;
    var rules = rule.rules;
    var ruleLogic = '';
    var logicalOperator = rule.logicalOperator ? this.getLogicalOperator(rule.logicalOperator) : false;
    if (rules.length > 1) {
      rules.map(function (ruleItem, index) {
        var constraint = _this16.getConstraint(ruleItem.constraint);
        var questionId = ruleItem.questionId;
        var optionId = ruleItem.optionId;
        // add new rules
        var typeId = ruleItem.type;
        var value = ruleItem.value;
        if (constraint) {
          if (typeId === 'LocationRule') {
            ruleLogic = ruleLogic + (_this16.props.locationId ? '(' + _this16.props.locationId + ' ' + constraint + ' ' + value + ')' : false);
          } else {
            ruleLogic = ruleLogic + (_this16.state.feedback_data[questionId] ? '(' + _this16.state.feedback_data[questionId].optionId + ' ' + constraint + ' ' + optionId + ')' : false);
          }
          if (index !== rules.length - 1) {
            ruleLogic = ruleLogic + logicalOperator;
          }
        }
      });
    } else {
      var constraint = this.getConstraint(rules[0].constraint);
      var questionId = rules[0].questionId;
      var optionId = rules[0].optionId;
      var typeId = rules[0].type;
      var value = rules[0].value;
      if (constraint) {
        if (typeId === 'LocationRule') {
          ruleLogic = ruleLogic + (this.props.locationId ? '(' + this.props.locationId + ' ' + constraint + ' ' + value + ')' : false);
        } else {
          ruleLogic = this.state.feedback_data[questionId] ? this.state.feedback_data[questionId].optionId + ' ' + constraint + ' ' + optionId : false;
        }
      }
    }
    return this.eval(ruleLogic);
  };

  SurveyQuestions.prototype.isAutoSkippableQuestion = function isAutoSkippableQuestion() {
    var currentQuestion = this.state.current_question;
    var optionType = !currentQuestion.questionGroup ? currentQuestion.renderType : 'Group Question';
    return ['Single Select', 'Date', 'NPS', 'Star Rating', 'Slider', 'Number Slider', 'Dropdown'].indexOf(optionType) !== -1 ? true : false;
  };

  SurveyQuestions.prototype.showLocations = function showLocations() {
    var retVal = false;
    if (!this.props.locationId && this.state.show_locations) {
      this.state.current_page = 'location';
      this.state.tmp_location = this.state.location_id;
      retVal = true;
    }
    return retVal;
  };

  SurveyQuestions.prototype.showSurveys = function showSurveys() {
    var retVal = false;
    if (this.state.location_id && !this.props.surveyId && this.state.show_surveys) {
      this.state.current_page = 'survey';
      this.state.tmp_survey = this.state.survey_id;
      retVal = true;
    }
    return retVal;
  };

  SurveyQuestions.prototype.showProviders = function showProviders() {
    var retVal = false;
    if (this.state.location_id && this.state.survey_id && !this.props.providerId && this.state.show_providers) {
      this.state.current_page = 'provider';
      this.state.tmp_provider = this.state.provider_id;
      retVal = true;
    }
    return retVal;
  };

  SurveyQuestions.prototype.showQuestions = function showQuestions() {
    var retVal = false;
    if (this.state.location_id && this.state.survey_id && this.state.provider_id && this.state.show_questions) {
      this.state.current_page = 'questions';
      retVal = true;
    }
    return retVal;
  };

  SurveyQuestions.prototype.selectLocation = function selectLocation(location) {
    this.state.tmp_location = location.id;
    this.state.location_id = location.id;
  };

  SurveyQuestions.prototype.selectSurvey = function selectSurvey(survey) {
    this.state.tmp_survey = survey.id;
    this.state.survey_id = survey.id;
  };

  SurveyQuestions.prototype.selectProvider = function selectProvider(provider) {
    this.state.tmp_provider = provider.id;
    this.state.provider_id = provider.id;
  };

  SurveyQuestions.prototype.submitSurvey = function submitSurvey() {
    var _this17 = this;

    if (this.props.survey.showAnonymous) {
      this.setState({
        show_anonymous_dialog: !this.state.show_anonymous_dialog
      }, function () {
        _this17.props.onSubmit(_this17.state.feedback_data, _this17.state.anonymous_survey);
      });
    } else {
      this.props.onSubmit(this.state.feedback_data, this.state.anonymous_survey);
    }
  };

  SurveyQuestions.prototype.dateChange = function dateChange(value) {
    var dateVal = this.state.feedback_data[this.state.current_question.id] && this.state.feedback_data[this.state.current_question.id].response ? (0, _momentTimezone2.default)(this.state.feedback_data[this.state.current_question.id].response, 'MM-DD-YYYY').format('MM-DD-YYYY') : (0, _momentTimezone2.default)(new Date(), 'MM-DD-YYYY').format('MM-DD-YYYY');
    if (this.checkDate(value)) {
      this.setData(1, (0, _momentTimezone2.default)(value, 'MM-DD-YYYY').format('MM-DD-YYYY'));
    } else {
      this.refs.date_box_mobile.value = dateVal;
    }
  };

  SurveyQuestions.prototype.dateBlur = function dateBlur(event) {
    var value = event.target.value;
    var dateVal = this.state.feedback_data[this.state.current_question.id] && this.state.feedback_data[this.state.current_question.id].response ? (0, _momentTimezone2.default)(this.state.feedback_data[this.state.current_question.id].response, 'MM-DD-YYYY').format('MM-DD-YYYY') : (0, _momentTimezone2.default)(new Date(), 'MM-DD-YYYY').format('MM-DD-YYYY');
    if (!this.checkDate(value)) {
      this.setData(1, (0, _momentTimezone2.default)(dateVal, 'MM-DD-YYYY').format('MM-DD-YYYY'));
      document.getElementById('date_box_mobile_' + this.state.sequence_no).value = dateVal;
    }
  };

  SurveyQuestions.prototype.checkDate = function checkDate(date) {
    var allowedDateFormats = ['MM-DD-YYYY'];
    return (0, _momentTimezone2.default)(date, allowedDateFormats, true).isValid();
  };

  SurveyQuestions.prototype.hideDoneButton = function hideDoneButton() {
    document.body.className = document.body.className.replace(/\bmobile_device\b/, '');
    document.body.className = document.body.className.replace(/\mobile_device_iphone\b/, '');
  };

  SurveyQuestions.prototype.render = function render() {
    var _this18 = this;

    return _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'div',
        { className: this.styles.survey_question_container, style: { width: '100%', margin: '0px' }, id: 'survey_questions_page' },
        _react2.default.createElement(
          _Grid2.default,
          null,
          _react2.default.createElement(
            _reactAddonsCssTransitionGroup2.default,
            { transitionName: this.state.current_move === 'forward' ? 'slide-top' : 'slide-bottom' },
            this.getPageContent()
          ),
          _react2.default.createElement(
            _Row2.default,
            { className: this.styles.survey_questions_footer, id: 'survey_questions_footer' },
            _react2.default.createElement(
              _Col2.default,
              { xs: 4, sm: 4, md: 4, className: this.styles.footer_button_container },
              _react2.default.createElement(
                'div',
                { className: this.styles.back_button_container },
                this.state.sequence_no !== 1 && this.getBackButton()
              )
            ),
            _react2.default.createElement(
              _Col2.default,
              { xs: 4, sm: 4, md: 4, className: this.styles.footer_button_container },
              _react2.default.createElement(
                'div',
                { className: this.styles.page_number_container },
                this.getPageNumber()
              )
            ),
            _react2.default.createElement(
              _Col2.default,
              { xs: 4, sm: 4, md: 4, className: this.styles.footer_button_container },
              _react2.default.createElement(
                'div',
                { className: this.styles.next_button_container },
                this.getNextButton()
              )
            )
          ),
          _react2.default.createElement(
            _Row2.default,
            { className: this.styles.mobile_done_button_wrapper, id: 'mobile_done_button_wrapper' },
            _react2.default.createElement(_Col2.default, { xs: 4, sm: 4, md: 4 }),
            _react2.default.createElement(_Col2.default, { xs: 4, sm: 4, md: 4 }),
            _react2.default.createElement(
              _Col2.default,
              { xs: 4, sm: 4, md: 4 },
              _react2.default.createElement(_mozart_ui.MozartButton, {
                background: this.props.theme && this.props.theme.colorCode ? this.props.theme.colorCode : true,
                color: this.props.theme && this.props.theme.customTextColor ? this.props.theme.customTextColor : '#fff',
                style: { border: '1px solid ' + this.props.theme.colorCode },
                data: 'Done',
                onClick: this.hideDoneButton.bind(this)
              })
            )
          )
        ),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_mozart_ui.MozartModal, {
            title: 'Survey Submission',
            key: 'anonymousSurveyDialog',
            children: _react2.default.createElement(
              'div',
              { className: this.styles.anonymous_checkbox },
              _react2.default.createElement(
                _mozart_ui.MozartCheckBox,
                null,
                _react2.default.createElement('input', {
                  ref: 'checkbox_anonymous_survey',
                  type: 'checkbox',
                  id: 'checkbox_anonymous_survey',
                  name: 'checkbox_anonymous_survey',
                  onChange: this.setAnonymousSurvey.bind(this),
                  checked: this.state.anonymous_survey
                }),
                _react2.default.createElement(
                  'label',
                  { style: { marginRight: '10px' }, htmlFor: 'checkbox_anonymous_survey', title: 'checkbox' },
                  'Submit survey as anonymous'
                )
              )
            ),
            submitLabel: 'Submit',
            handleSubmit: this.submitSurvey.bind(this),
            show: this.state.show_anonymous_dialog,
            width: this.state.device_type === 'mobile' ? '80%' : '700px',
            onClose: function onClose() {
              _this18.toggleAnonymousModal();
            }
          })
        )
      )
    );
  };

  return SurveyQuestions;
}(_react.Component), _class2.propTypes = {
  survey: _react.PropTypes.object,
  params: _react.PropTypes.object,
  theme: _react.PropTypes.object,
  createdAudienceInfo: _react.PropTypes.object,

  audienceInfo: _react.PropTypes.object,
  onSubmit: _react.PropTypes.func,
  checkDevice: _react.PropTypes.func,
  createAudience: _react.PropTypes.func,
  getTextForLanguage: _react.PropTypes.func,

  surveyId: _react.PropTypes.number,
  locationId: _react.PropTypes.number,
  providerId: _react.PropTypes.number,

  selectedLanguage: _react.PropTypes.string,

  previewMode: _react.PropTypes.boolean
}, _temp)) || _class);
exports.default = SurveyQuestions;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/SurveyQuestions/SurveyQuestions.js
// module id = 2310
// module chunks = 0